import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

export const HALL_ROLES_ENDPOINT = 'https://api.airaops.com/api/v1/roles';

export const fetchHallRoles = createAsyncThunk(
  'roles/fetchHallRoles',
  async (_, { rejectWithValue, signal }) => {
    try {
      const response = await api.get(HALL_ROLES_ENDPOINT, {
        params: {
          page: 1,
          limit: 50,
        },
        signal,
      });


      console.log(response.data, 'response.data##########');
      return response.data;
    } catch (error) {
      if (error?.name === 'CanceledError' || signal?.aborted) {
        return rejectWithValue('Request cancelled');
      }

      return rejectWithValue(
        error?.response?.data?.message ??
          error?.response?.data?.error ??
          error?.message ??
          'Failed to fetch hall roles',
      );
    }
  },
);

export const fetchAllRoles = fetchHallRoles;
